module.exports = __webpack_public_path__ + "img/event2.7c222443.png";